<template>
  <div class="text-chicago">
    <template v-if="!checked">
      <button
        type="button"
        class="flex items-center text-left flex-nowrap py-3 w-full"
        @click="nav.click"
        v-if="nav.type === 'button'"
      >
        <span class="flex-grow">
          {{ nav.text }}
        </span>
        <ChevronRightIcon class="flex-none text-gray-400" />
      </button>

      <nuxt-link
        v-else
        :to="nav.to"
        class="flex items-center text-left flex-nowrap py-3 w-full"
      >
        <span class="flex-grow">
          {{ nav.text }}
        </span>
        <ChevronRightIcon class="flex-none text-gray-400" />
      </nuxt-link>
    </template>
    <div v-else class="flex items-center text-left flex-nowrap py-3 w-full">
      <span class="flex-grow">
        {{ nav.text }}
      </span>
      <CheckCircleIcon class="flex-none text-green-600" />
    </div>
  </div>
</template>

<script>
import { ChevronRightIcon, CheckCircleIcon } from "@vue-hero-icons/outline";
export default {
  components: {
    ChevronRightIcon,
    CheckCircleIcon,
  },
  props: {
    nav: {
      type: Object,
    },
    checked: Boolean,
  },
};
</script>

<style lang="scss" scoped></style>
